import React, { memo } from "react";
import { ActivityIndicator, StyleSheet, View } from "react-native";
import { connect } from "react-redux";
import strings from "@constants";
import colors from "@constants/color";
import refreshHOC from "@utils/refreshHOC";
import useCMSEvents from "../../hooks/useCMSEvents";
import { getAddedProductListIds } from "../../reducers/cartReducer";
import FetchCMSEntity from "./FetchCMSEntity";

const { refresh: refreshScreenName } = strings;
const DynamicCMSListing = memo((props) => {
  const { route: { params: { entityId } = {}, name = "" } = {} } = props;
  const trackEvent = useCMSEvents(name);

  return entityId ? (
    <View style={styles.whiteBg}>
      <FetchCMSEntity id={entityId} trackEvent={trackEvent} />
    </View>
  ) : (
    <View style={styles.stretchFill}>
      <ActivityIndicator color={colors.primary} size={"large"} />
    </View>
  );
});

const mstp = ({ cart, auth }) => {
  return {
    user_id: auth.user?.user_id,
    currentCartSkuIds: getAddedProductListIds(cart),
  };
};

const styles = StyleSheet.create({
  whiteBg: {
    backgroundColor: "#e5e5e5",
  },
  stretchFill: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default connect(mstp)(
  refreshHOC(refreshScreenName.dynamicCMSListing)(DynamicCMSListing),
);
